var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNotification = function SvgNotification(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.52 1.84c-1.568 0.272-3.248 0.896-4.688 1.712-1.696 0.944-4.336 3.584-5.28 5.28-2.576 4.576-2.576 9.92 0 14.496 0.944 1.696 3.584 4.336 5.28 5.28 4.576 2.576 9.92 2.576 14.496 0 1.696-0.944 4.336-3.584 5.28-5.28 2.576-4.576 2.576-9.92 0-14.496-0.944-1.696-3.584-4.336-5.28-5.28-2.992-1.696-6.544-2.32-9.808-1.712zM19.328 4.48c4.064 1.136 7.2 4.304 8.384 8.432 0.496 1.76 0.496 4.576 0 6.336-1.184 4.16-4.304 7.28-8.464 8.464-1.76 0.496-4.576 0.496-6.336 0-4.16-1.184-7.28-4.304-8.464-8.464-0.496-1.76-0.496-4.576 0-6.336 1.312-4.624 4.944-7.872 9.76-8.752 1.168-0.224 3.808-0.048 5.12 0.32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.408 9.040c-1.008 0.432-1.040 0.944-0.4 5.824 0.384 2.88 0.464 3.28 0.768 3.488 0.288 0.192 0.384 0.176 0.672-0.064 0.272-0.256 0.384-0.768 0.736-3.728 0.592-4.768 0.56-5.024-0.384-5.52-0.56-0.288-0.736-0.288-1.392 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.024 21.104c-0.608 0.624-0.624 1.28 0 1.968 0.352 0.4 0.576 0.512 1.056 0.512s0.704-0.112 1.056-0.512c0.624-0.688 0.608-1.344 0-1.968-0.656-0.64-1.456-0.64-2.112 0z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotification, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notification.b3a6674e.svg";
export { ForwardRef as ReactComponent };